import { Team } from "@brg/api";
import { FlexBox } from "@brg/ui";
import { LayoutConst } from "core";
import { FC, useMemo } from "react";
import { ModerationTypeShortNames } from "shared/pages/teams/const/ModerationTypes";
import styled from "styled-components";

export const LabelWrapper = styled(FlexBox)`
    // height: 100%;
    // align-self: flex-end;
    display: inline-flex;

    svg {
        width: 32px;
        height: 32px;
    }

`;

export const Label = styled.span`
    display: inline-block;
    color: #909090;
    font-size: 30px;
    line-height: 60px;
    margin-left: 8px;
    text-transform: lowercase;

    @media(max-width: ${LayoutConst.screen.l_12}px) {
        font-size: 17px;
        line-height: 44px;
    }
`;

export const CourseLabel: FC<{ team?: Team}> = ({ team }) => {
    
    return (
        <LabelWrapper>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4.4059 11.7842C4.18179 12.0081 4.18179 12.3713 4.4059 12.5952C4.62973 12.8188 4.99239 12.8188 5.21622 12.5952L10.8719 6.94475L10.8719 11.0474C10.8719 11.3603 11.1267 11.6134 11.4396 11.6114C11.7497 11.6094 12 11.3574 12 11.0474L12 5.46486C12 5.21211 11.7953 5.00714 11.5425 5.00686L5.96064 5.00064C5.64408 5.00029 5.38784 5.2579 5.38988 5.57446C5.39191 5.88824 5.64712 6.1414 5.96091 6.14091L10.0608 6.13444L4.4059 11.7842Z" fill="#151514"/>
</svg>

        </LabelWrapper>
    )
}import { Team } from "@brg/api";
import { FlexBox } from "@brg/ui";
import { LayoutConst } from "core";
import { FC, useMemo } from "react";
import { ModerationTypeShortNames } from "shared/pages/teams/const/ModerationTypes";
import styled from "styled-components";

export const LabelWrapper = styled(FlexBox)`
    // height: 100%;
    // align-self: flex-end;
    display: inline-flex;

    svg {
        width: 32px;
        height: 32px;
    }

`;

export const Label = styled.span`
    display: inline-block;
    color: #909090;
    font-size: 30px;
    line-height: 60px;
    margin-left: 8px;
    text-transform: lowercase;

    @media(max-width: ${LayoutConst.screen.l_12}px) {
        font-size: 17px;
        line-height: 44px;
    }
`;

export const CourseLabel: FC<{ team?: Team}> = ({ team }) => {
    
    return (
        <LabelWrapper>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4.4059 11.7842C4.18179 12.0081 4.18179 12.3713 4.4059 12.5952C4.62973 12.8188 4.99239 12.8188 5.21622 12.5952L10.8719 6.94475L10.8719 11.0474C10.8719 11.3603 11.1267 11.6134 11.4396 11.6114C11.7497 11.6094 12 11.3574 12 11.0474L12 5.46486C12 5.21211 11.7953 5.00714 11.5425 5.00686L5.96064 5.00064C5.64408 5.00029 5.38784 5.2579 5.38988 5.57446C5.39191 5.88824 5.64712 6.1414 5.96091 6.14091L10.0608 6.13444L4.4059 11.7842Z" fill="#151514"/>
</svg>

        </LabelWrapper>
    )
}